import { call, put, select, all } from "redux-saga/effects";
import { addItemRequest, getItemsRequest, updateItemRequest } from "../../spItems/api";
import { VPORequirementsConditionsListName, VPOStatusQuestionnaireListName } from "src/api/config";
import { copyPrevMonthSuccess, setConditionSuccess } from "../actions";
import { getDefaultSaga } from "./getDefaultSaga";
import { updateDefaultSaga } from "src/modules/spItems/sagas/updateDefaultSaga";
import { addDefaultSaga } from "src/modules/spItems/sagas/addDefaultSaga";
import { ContentTypeIdRequirement } from "../api/config";
import { deleteDefaultSaga } from "src/modules/spItems/sagas/deleteDefaultSaga";
import { getSaga } from "./itemsWatcher";

function extractPath(inputStr: any) {
  const parts = inputStr.split('/'); // Разбиваем строку на части по "/"
  parts.pop(); // Удаляем последний элемент
  return parts.join('/'); // Объединяем оставшиеся части обратно в строку
}

// Функция для извлечения числа перед последним "_"
function extractNumber(inputStr: any) {
  const parts = inputStr.split('/'); // Разбиваем строку на части по "/"
  const lastPart = parts[parts.length - 2]; // Берем предпоследний элемент
  return lastPart.split('_')[0]; // Убираем все после "_"
}

export function* copyPrevMonthSaga({ payload }: any) {
  try {
    if (payload) {

      const {
        ColumnID,
        GroupID,
        FactoryID,
        Status,
        Month,
        Year,
        departments
      } = payload;

      let is_end_questionary = false,
          prev_month = Month - 1,
          prev_year = Year,
          current_status_questionary_id = null,
          prev_status_questionary = {},
          current_status_report_region: any = [],
          prev_status_report_region:any = [];

          if(prev_month === 0){
            prev_month = 12;
            prev_year = prev_year - 1;
          }


      // Status questionary

      let response_status_prev_questionary : unknown = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        filtersType: 'and',
        filters: {
          ColumnID: '*'+ColumnID,
          GroupID: '*'+GroupID,
          FactoryID: ''+FactoryID,
          // Status,
          Month: ''+prev_month,
          Year: ''+prev_year
        },
      });

      if(
        response_status_prev_questionary &&
        response_status_prev_questionary.items &&
        response_status_prev_questionary.items.length > 0
      ){
        response_status_prev_questionary.items.map((item) => {
          prev_status_questionary = item;
        })
      }

      let response_status_current_questionary : unknown = yield call<any>(getDefaultSaga, {
        listName: VPOStatusQuestionnaireListName,
        filtersType: 'and',
        filters: {
          ColumnID: '*'+ColumnID,
          GroupID: '*'+GroupID,
          FactoryID: ''+FactoryID,
          // Status,
          Month: ''+Month,
          Year: ''+Year
        },
      });

      if(
        response_status_current_questionary &&
        response_status_current_questionary.items &&
        response_status_current_questionary.items.length > 0
      ){
        response_status_current_questionary.items.map((item) => {
          current_status_questionary_id = item.ID;
        })
      }

      if(
        prev_status_questionary &&
        current_status_questionary_id
      ){

        yield call<any>(updateDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,          
          body: {
            ...prev_status_questionary,
            ID: current_status_questionary_id
          }
        })

      } else if(
        !prev_status_questionary &&
        current_status_questionary_id
      ) {

        yield call<any>(updateDefaultSaga, {
          listName: VPOStatusQuestionnaireListName,          
          body: {
            ...prev_status_questionary,
            CountYes: '0',
            ID: current_status_questionary_id
          }
        })

      }



      // Report Region

      let all_report_region:any = [];
      let all_report_region_add:any = [];
      let all_report_region_update:any = [];

      let response_status_prev_report_region : unknown = yield call<any>(getDefaultSaga, {
        listName: 'ReportRegion',
        filtersType: 'and',
        filters: {
          ColumnID: '*'+ColumnID,
          GroupID: '*'+GroupID,
          FactoryID: ''+FactoryID,
          // Status,
          Month: ''+prev_month,
          Year: ''+prev_year
        },
      });

      let response_status_current_report_region : unknown = yield call<any>(getDefaultSaga, {
        listName: 'ReportRegion',
        filtersType: 'and',
        filters: {
          ColumnID: '*'+ColumnID,
          GroupID: '*'+GroupID,
          FactoryID: ''+FactoryID,
          // Status,
          Month: ''+Month,
          Year: ''+Year
        },
      });

      if(
        response_status_current_report_region &&
        response_status_current_report_region.items &&
        response_status_current_report_region.items.length > 0
      ){
        response_status_current_report_region.items.map((item) => {
          all_report_region.push(item);

          if(
            response_status_prev_report_region.items.findIndex(el => el.SubdivisionID == item.SubdivisionID) < 0
          ){
            all_report_region_update.push({
              ...item,
              CountYes: '0'
            });
          }

        })
      }

      if(
        response_status_prev_report_region &&
        response_status_prev_report_region.items &&
        response_status_prev_report_region.items.length > 0
      ){
        response_status_prev_report_region.item.map((item) => {

          if(all_report_region.findIndex(el => el.SubdivisionID == item.SubdivisionID) < 0){

            let find_item_report_region = all_report_region.filter(el => el.SubdivisionID == item.SubdivisionID);

            if(
              find_item_report_region &&
              find_item_report_region.length > 0
            ){

              all_report_region_update.push({
                ...item,
                ID: find_item_report_region[0].ID
              });
              
            }

          } else {
            
            delete item.ID;

            all_report_region_add.push({
              ...item,
              CountYes: '0'
            });

          }

        });
      }

      // console.log('all_report_region_update', all_report_region_update);

      // console.log('all_report_region_add', all_report_region_add);

      if(
        all_report_region_add && 
        all_report_region_add.length > 0
      ){
        yield all(all_report_region_add.map((item) => {
          return call(addDefaultSaga, {
            listName: 'ReportRegion',
            body: {
              Title: item.Title,
              ColumnID: item.ColumnID,
              ColumnTitle: item.ColumnTitle,
              GroupID: item.GroupID,
              GroupTitle: item.GroupTitle,
              FactoryID: item.FactoryID,
              FactoryTitle: item.FactoryTitle,
              Month: item.Month,
              Year: item.Year,
              SubdivisionID: item.SubdivisionID,
              SubdivisionTitle: item.SubdivisionTitle,
              CountYes: item.CountYes,
              CountQuestions: item.CountQuestions,	
              CountNull: item.CountNull
            }
          })
        }))
      }

      if(
        all_report_region_update && 
        all_report_region_update.length > 0
      ){
        yield all(all_report_region_update.map((item) => {
          return call(updateDefaultSaga, {
            listName: 'ReportRegion',
            body: {
              ID: item.ID,
              Title: item.Title,
              ColumnID: item.ColumnID,
              ColumnTitle: item.ColumnTitle,
              GroupID: item.GroupID,
              GroupTitle: item.GroupTitle,
              FactoryID: item.FactoryID,
              FactoryTitle: item.FactoryTitle,
              Month: item.Month,
              Year: item.Year,
              SubdivisionID: item.SubdivisionID,
              SubdivisionTitle: item.SubdivisionTitle,
              CountYes: item.CountYes,
              CountQuestions: item.CountQuestions,	
              CountNull: item.CountNull
            }
          })
        }))
      }

      // if(
      //   all_report_region &&
      //   all_report_region.length > 0
      // ){
      //   all_report_region.map((item) => {
      //     let CountYes = '0';
      //     return {
      //       ...item,
      //       CountYes
      //     }
      //   })
      // }








      let response_requirements : unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        filtersType: 'and',
        filters: {
          ContentTypeId: '^' + ContentTypeIdRequirement,
          FileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
        },
      })

      // if(
      //   response_status_questionary &&
      //   response_status_questionary.items &&
      //   response_status_questionary.items.length > 0
      // ){
      //   is_end_questionary = true;
      // }

      // if(
      //   is_end_questionary
      // ){

        const response_requirement_conditions_prev: unknown = yield call<any>(getDefaultSaga, {
          listName: VPORequirementsConditionsListName,
          filters: {
            GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
            Month: '' + prev_month,
            Year: '' + prev_year,
            FactoryID: ''+FactoryID,
          },
        });

        const response_requirement_conditions: unknown = yield call<any>(getDefaultSaga, {
          listName: VPORequirementsConditionsListName,
          filters: {
            GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
            Month: '' + Month,
            Year: '' + Year,
            FactoryID: ''+FactoryID,
          },
        });

        if(
          response_requirement_conditions &&
          response_requirement_conditions.items &&
          response_requirement_conditions.items.length > 0
        ){
          yield all(response_requirement_conditions.items.map((condition: any) => {
            return call<any>(deleteDefaultSaga, {
              listName: VPORequirementsConditionsListName,
              ID: condition.ID
            })
          }))
        }

        if(
          response_requirements &&
          response_requirements.items &&
          response_requirements.items.length > 0 &&
          response_requirement_conditions_prev &&
          response_requirement_conditions_prev.items &&
          response_requirement_conditions_prev.items.length > 0 &&
          departments &&
          departments.length > 0
        ){
          
          let copy_conditions: any = [];

          response_requirements.items.map((requirement: any) => {
            departments.map((department: any) => {

              let id_find_condition = null;

              let find_condition = response_requirement_conditions_prev.items.filter((el: any) => {
                if(
                  el.Subdivision &&
                  el.Subdivision.get_lookupId() &&
                  el.Requirement &&
                  el.Requirement.get_lookupId()
                ){
                  return el.Subdivision.get_lookupId() === department.id && el.Requirement.get_lookupId() === requirement.ID
                }
              })

              if(
                find_condition &&
                find_condition.length > 0 &&
                find_condition[0].Condition &&
                find_condition[0].Condition.get_lookupId()
              ){
                id_find_condition = find_condition[0].Condition.get_lookupId();
              }
              
              if(id_find_condition){

                copy_conditions.push({
                  Title: 'Ответ',
                  Condition: id_find_condition,
                  Requirement: requirement.ID,
                  Subdivision: department.id,
                  GroupRequirementID: extractNumber(extractPath(requirement.FileRef)),
                  GroupRequirementFileRef: extractPath(requirement.FileRef),
                  Month: Month,
                  Year: Year,
                  FactoryID: FactoryID
                })

              }
            })
          })

          if(
            copy_conditions &&
            copy_conditions.length > 0
          ){
            yield all<any>(copy_conditions.map((item: any) => {
              return call<any>(addDefaultSaga, {
                listName: VPORequirementsConditionsListName,
                body: {
                  ...item
                }
              })
            }))
          }
        }

      // }

      yield call<any>(getSaga, {
        payload: {
          listName: VPORequirementsConditionsListName,
          contentType: VPORequirementsConditionsListName,
          filters: {
            GroupRequirementFileRef: '*' + ColumnID + '_.000/' + GroupID + '_.000',
            Month: '' + Month,
            Year: '' + Year,
            FactoryID: ''+FactoryID,
          },
        }
      })

      yield put(copyPrevMonthSuccess({
        isSuccess: true
      }))

    }
  } catch (error) {
    console.log(error);
  }
}
